import { AnyAction } from 'redux';
import { FaqType } from 'domain/types/faq.type';
import { FaqReducerType } from 'model/reducers/FaqReducerType';

const initialState: FaqReducerType = {
  faqs: [],
  error: null,
  insertSuccess: false,
  updateSuccess: false
};

/**
 * FAQ reducer for managing FAQ-related state
 */
const faqReducer = (state = initialState, action: AnyAction): FaqReducerType => {
  const { type, payload } = action;
  
  switch (type) {
    case FaqType.FETCH_FAQS_REQUEST:
      return {
        ...state,
        error: null
      };
      
    case FaqType.FETCH_FAQS_SUCCESS:
      return {
        ...state,
        faqs: payload.faqs,
        error: null
      };
      
    case FaqType.FETCH_FAQS_FAILURE:
      return {
        ...state,
        error: payload.error
      };

    case FaqType.INSERT_FAQ_REQUEST:
      return {
        ...state,
        insertSuccess: false,
        error: null
      };

    case FaqType.INSERT_FAQ_SUCCESS:
      return {
        ...state,
        insertSuccess: true,
        error: null
      };

    case FaqType.INSERT_FAQ_FAILURE:
      return {
        ...state,
        insertSuccess: false,
        error: payload.error
      };

    case FaqType.UPDATE_FAQ_REQUEST:
      return {
        ...state,
        updateSuccess: false,
        error: null
      };

    case FaqType.UPDATE_FAQ_SUCCESS:
      return {
        ...state,
        updateSuccess: true,
        error: null
      };

    case FaqType.UPDATE_FAQ_FAILURE:
      return {
        ...state,
        updateSuccess: false,
        error: payload.error
      };
      
    default:
      return state;
  }
};

export default faqReducer;